import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBodyType } from "../apiHandler/bodytype.service";

export const bodyTypeAsync = createAsyncThunk(
  "bodyType/tableDataAsync",
  async (params: any) => {
    // Simulate an asynchronous operation, e.g., fetching data from an API
    const data: any = await getBodyType(params);

    if (data === "Forbidden") window.location.href = "/";
    if (data.data) return data.data;
  }
);
